// Merkan · Support-Anfragen an parlinex (KI-07, Migrationen 0134 und 0164)
// Das Formular (src/seiten/benachrichtigungen/SupportDialog.tsx) öffnet sich über supportOeffnen() von überall:
// Menü („Support“), Hilfe, Hugo. supportAnfrageSenden() legt die Anfrage in support_anfragen an; ein Trigger vergibt
// die Nummer S-JJJJ-NNNN und stellt die Anfrage als neue Nachricht in den Service Hub von parlinex.
import { supabase } from './supabase';
import { t, sprache } from './sprache';

export type SupportArt = 'frage' | 'fehler' | 'wunsch';

/** Gerät und Browser in Worten, z. B. "Chrome auf macOS, 1440 × 900" */
export function geraetText(): string {
  const ua = navigator.userAgent;
  const browser = /Edg\//.test(ua) ? 'Edge' : /Firefox\//.test(ua) ? 'Firefox' : /Chrome\//.test(ua) ? 'Chrome' : /Safari\//.test(ua) ? 'Safari' : t('Browser');
  const system = /iPhone/.test(ua) ? 'iPhone' : /iPad/.test(ua) ? 'iPad' : /Android/.test(ua) ? 'Android' : /Mac OS X/.test(ua) ? 'macOS' : /Windows/.test(ua) ? 'Windows' : /Linux/.test(ua) ? 'Linux' : '';
  const breite = `${window.innerWidth} × ${window.innerHeight}`;
  return system ? t('{browser} auf {system}, {breite}', { browser, system, breite }) : t('{browser}, {breite}', { browser, breite });
}

/** Lesbarer Name der aktuellen Seite: Überschrift der Seite und Pfad */
export function seitenName(pfad: string): string {
  const h = document.querySelector('main.inhalt h1')?.textContent?.trim();
  return h ? `${h} (${pfad})` : pfad;
}

/** Erster Buchstabe groß, Leerraum zusammengefasst, gekürzt (für einen Betreff aus einer Frage) */
export function alsBetreff(s: string, laenge = 120): string {
  const r = s.replace(/\s+/g, ' ').trim().slice(0, laenge);
  return r.charAt(0).toLocaleUpperCase() + r.slice(1);
}

export interface SupportErgebnis { ok: boolean; id?: string; nummer?: string; hinweis?: string }

export async function supportAnfrageSenden(mandantId: string, a: {
  art: SupportArt; betreff: string; text: string; dringend?: boolean; quelle: 'hilfe' | 'hugo'; kontext?: Record<string, unknown>;
}): Promise<SupportErgebnis> {
  const betreff = a.betreff.replace(/\s+/g, ' ').trim().slice(0, 160);
  const frage = (a.text.trim() || betreff).slice(0, 8000);
  try {
    const { data, error } = await supabase.from('support_anfragen').insert({
      mandant_id: mandantId, frage, betreff: betreff || null, art: a.art, dringend: Boolean(a.dringend), quelle: a.quelle,
      kontext: { sprache: sprache(), ...(a.kontext ?? {}) },
    }).select('id, nummer').single();
    if (error) {
      if (/Failed to fetch|NetworkError/i.test(error.message)) return { ok: false, hinweis: t('Keine Verbindung zum Server. Deine Eingaben bleiben erhalten, bitte gleich noch einmal senden.') };
      if (/Anfragen gesendet/.test(error.message)) return { ok: false, hinweis: t('Du hast in der letzten Stunde schon viele Anfragen gesendet. Bitte versuche es etwas später erneut.') };
      return { ok: false, hinweis: t('Die Anfrage konnte nicht gesendet werden. Bitte versuche es noch einmal oder schreib an support@parlinex.io.') };
    }
    const r = data as { id: string; nummer: string | null };
    return { ok: true, id: r.id, nummer: r.nummer ?? undefined };
  } catch {
    return { ok: false, hinweis: t('Keine Verbindung zum Server. Deine Eingaben bleiben erhalten, bitte gleich noch einmal senden.') };
  }
}

/** Meldet eine gesendete Anfrage an alle Stellen, die darauf warten (z. B. die Karte in Hugo) */
export function supportGesendetMelden(bezug: string | undefined, nummer: string) {
  window.dispatchEvent(new CustomEvent<{ bezug?: string; nummer: string }>('merkan:support-gesendet', { detail: { bezug, nummer } }));
}
